// src/app/modules/Reports/ReportsPage.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Reports } from "./Reports";
import { ReportView } from "./ReportView";

export function ReportsPage() {
  return (
    <Routes>
      <Route path="/" element={<Reports />} />
      <Route path="/view/:id" element={<ReportView />} />
      <Route path="*" element={<Navigate to="/reports" replace />} />
    </Routes>
  );
}